var $7b97fcacd84ec90f$exports = {};
$7b97fcacd84ec90f$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "Odabir boje",
  "colorSwatch": "uzorak boje",
  "transparent": "transparentno",
  "twoDimensionalSlider": "2D kliza\u010D"
};
export { $7b97fcacd84ec90f$exports as default };